import { useAtomValue } from "jotai";
import { questionnaireValidationsAtom } from "../state/questionnaireValidationsAtom";
import type { RuleSet } from "../../../components/Questionnaire/validation/form/types";

/**
 * Get validation rules for the questionnaire.
 *
 * @example const validations = useValidations();
 */
export function useValidations(): readonly RuleSet[] | undefined {
  return useAtomValue(questionnaireValidationsAtom);
}
